module.exports = __webpack_public_path__ + "static/media/banner-en.212b8c76.mp4";